import type { Cookiebot } from '@/ts/types/cookiebot';

/**
 * Whenever cookiebot consent changes, refresh the page.
 * CookiebotOnAccept / CookiebotOnDecline also fire for returning visitors, so
 * only reload when Cookiebot reports a change during this request.
 */
const handleConsentChange = () => {
  const Cookiebot = window.Cookiebot;

  if (!Cookiebot || Cookiebot instanceof HTMLElement) {
    return;
  }

  if ((Cookiebot as Cookiebot).changed) {
    window.location.reload();
  }
};

export default function init() {
  window.addEventListener('CookiebotOnAccept', handleConsentChange);
  window.addEventListener('CookiebotOnDecline', handleConsentChange);
}
